import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../../components/Layouts/Layouts/Layout";
import MasterNavigationBar from "../../../components/Layouts/Layouts/MasterServicesLayout";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import { getURLbyEndPoint } from "../../../store/api";

const ChamberEventBooking = () => {
  const navigate = useNavigate();
  const [notificationData, setNotificationData] = useState([]);

  const fetchNotification = async () => {
    try {
      const response = await axios.get(
        getURLbyEndPoint("getNotificationStatus"),
      );
      if (response.status === 200) {
        setNotificationData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching notification status:", error);
    }
  };

  useEffect(() => {
    fetchNotification();
  }, []);

  return (
    <Layout>
      <MasterNavigationBar>
        <div className="d-flex flex-column px-3">
          <DashboardHeader
            heading="EVENTS / CHAMBER EVENT BOOKING"
            backUrl="/master-events"
          />
          <hr />

          <div className="d-flex justify-content-around mb-2">
            <button
              onClick={() => {
                navigate("/chamber-event/create");
              }}
              type="button"
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1"
              style={{ width: "35%" }}
            >
              <div className="gap-2 d-flex justify-content-center align-items-center">
                <span>CREATE EVENTS</span>
              </div>
            </button>
            <button
              type="button"
              onClick={() => {
                navigate("/chamber-event/view-booking");
              }}
              className="bg-color border-0 mt-4 p-2 px-3 rounded-1 position-relative d-inline-flex align-items-center justify-content-center"
              style={{ width: "35%" }}
            >
              <div className="gap-2 d-flex justify-content-center align-items-center">
                <span>VIEW EVENT BOOKING</span>
              </div>
              <span
                className="badge bg-primary position-absolute fs-6"
                style={{ top: "-8px", right: "-8px" }}
              >
                {notificationData.chamberBooking !== 0
                  ? notificationData.chamberBooking
                  : null}
              </span>
            </button>
          </div>
          <hr />
        </div>
      </MasterNavigationBar>
    </Layout>
  );
};

export default ChamberEventBooking;
